module.exports = __webpack_public_path__ + "img/merge.392d76db.svg";